import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import LandingDropdown from "../../components/LandingDropdown/LandingDropdown";
import LandingNav from "../../components/LandingNav/LandingNav";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import LandingCopyright from "../../components/LandingCopyright/LandingCopyright";
import SEO from "../../../../components/SEO/SEO";
import N8nChatbot from "../../../../components/N8nChatbot/N8nChatbot";
import localeText from "../../../../locale";
import "../../landing.css";
import HeroPhoto from "../../../images/landing/newphotos/hero-mercado.jpg";
import PadariaPhoto from "../../../images/landing/newphotos/negocio-padaria.jpg";

const iconProps = {
  width: "1.3rem",
  height: "1.3rem",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const UserRoundIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="8" r="5" />
    <path d="M20 21a8 8 0 0 0-16 0" />
  </svg>
);

const StoreIcon = () => (
  <svg {...iconProps}>
    <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
    <path d="M2 7h20" />
    <path d="M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" />
  </svg>
);

const RefreshCwIcon = () => (
  <svg {...iconProps}>
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
    <path d="M8 16H3v5" />
  </svg>
);

const getValues = () => [
  {
    iconNode: <UserRoundIcon />,
    title: localeText("lp2SobreValue1Title"),
    description: localeText("lp2SobreValue1Desc"),
  },
  {
    iconNode: <StoreIcon />,
    title: localeText("lp2SobreValue2Title"),
    description: localeText("lp2SobreValue2Desc"),
  },
  {
    iconNode: <RefreshCwIcon />,
    title: localeText("lp2SobreValue3Title"),
    description: localeText("lp2SobreValue3Desc"),
  },
];

const SobrePage = () => {
  const toast = useRef(null);
  const values = getValues();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <SEO
        title="Sobre | Extraconomy"
        description={localeText("lp2SobreSeoDescription")}
      />
      <Toast ref={toast} />

      <div
        style={{ backgroundColor: "#3E8B5C", margin: "0" }}
        className="flex align-items-center justify-content-between nav-responsive sticky top-0 z-3"
      >
        <LandingNav scrollToSection={scrollToSection} />
        <Link
          className="hidden xl:flex font-bold gap-3 xl:px-6 px-4 border-noround border-none p-button-no-outline p-button-cart-hover align-items-center text-white"
          style={{ backgroundColor: "#2A2560", fontSize: "16px", height: "100%" }}
          to="/shop"
        >
          <i style={{ fontSize: "24px" }} className="pi pi-shopping-cart"></i>{" "}
          <span className="hidden xl:inline font-system">{localeText("toTheStore")}</span>
        </Link>
        <div className="xl:hidden flex h-full">
          <LandingDropdown scrollToSection={scrollToSection} />
        </div>
      </div>

      <div className="bg-white content-grid landing">
        {/* Hero */}
        <section className="full-width py-6 md:py-8" style={{ backgroundColor: "var(--extra-soft)" }}>
          <div className="flex flex-wrap align-items-center gap-2 text-sm">
            <Link to="/" className="font-semibold no-underline" style={{ color: "var(--extra-green)" }}>
              {localeText("home")}
            </Link>
            <i className="pi pi-chevron-right text-xs" style={{ color: "var(--extra-body)" }}></i>
            <span style={{ color: "var(--extra-body)" }}>{localeText("lp2SobreBadge")}</span>
          </div>

          <div className="grid align-items-center mt-5">
            <div className="col-12 lg:col-6">
              <p className="eyebrow-text">{localeText("lp2SobreBadge")}</p>
              <h1
                className="mt-3 font-bold title"
                style={{
                  maxWidth: "13ch",
                  fontSize: "clamp(40px, 5vw, 66px)",
                  lineHeight: 1.06,
                  letterSpacing: "-0.03em",
                  color: "var(--extra-green)",
                }}
              >
                {localeText("lp2SobreH1")}
              </h1>
              <p
                className="mt-4 text-lg line-height-3"
                style={{ maxWidth: "52ch", color: "var(--extra-body)" }}
              >
                {localeText("lp2SobreHeroDesc")}
              </p>
              <div className="flex flex-column sm:flex-row gap-3 mt-5">
                <Link
                  to="/planos"
                  className="btn-yellow-cta border-round-md px-5 py-3 no-underline inline-flex align-items-center gap-2 justify-content-center"
                >
                  {localeText("lp2SobreCta1")} <i className="pi pi-arrow-right text-sm"></i>
                </Link>
                <Link
                  to="/empresas"
                  className="border-round-md px-5 py-3 font-bold no-underline text-center landing-card-hover"
                  style={{
                    border: "2px solid var(--extra-green)",
                    backgroundColor: "#fff",
                    color: "var(--extra-green)",
                  }}
                >
                  {localeText("lp2SobreCta2")}
                </Link>
              </div>
            </div>
            <div className="col-12 lg:col-6 mt-5 lg:mt-0">
              <div
                className="relative border-round-xl overflow-hidden"
                style={{ backgroundColor: "var(--extra-green-dark)", boxShadow: "0 20px 44px rgba(30,40,30,.12)" }}
              >
                <div
                  aria-hidden="true"
                  className="absolute border-circle"
                  style={{
                    width: "280px",
                    height: "280px",
                    right: "-80px",
                    top: "-80px",
                    border: "1px solid rgba(255,255,255,0.15)",
                  }}
                ></div>
                <div
                  aria-hidden="true"
                  className="absolute border-circle"
                  style={{
                    width: "280px",
                    height: "280px",
                    left: "-64px",
                    bottom: "-96px",
                    backgroundColor: "rgba(62,139,92,0.45)",
                  }}
                ></div>
                <img
                  src={HeroPhoto}
                  alt=""
                  className="relative w-full"
                  style={{ aspectRatio: "4 / 3", objectFit: "cover", zIndex: 1, display: "block" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Nossa ideia */}
        <section className="full-width bg-white py-6 md:py-8">
          <div style={{ maxWidth: "720px" }}>
            <p className="eyebrow-text">{localeText("lp2SobreIdeaEyebrow")}</p>
            <h2
              className="mt-3 font-bold title text-3xl sm:text-4xl"
              style={{ color: "var(--extra-green)", letterSpacing: "-0.02em" }}
            >
              {localeText("lp2SobreIdeaTitle")}
            </h2>
            <p className="mt-3 text-lg line-height-3" style={{ color: "var(--extra-body)" }}>
              {localeText("lp2SobreIdeaDesc")}
            </p>
          </div>

          <div className="grid mt-5 py-2">
            {values.map((value) => (
              <div key={value.title} className="col-12 md:col-6 lg:col-4">
                <div
                  className="landing-card-hover h-full p-4 border-round-lg"
                  style={{ backgroundColor: "#fff", border: "1px solid var(--extra-line)" }}
                >
                  <div
                    className="flex align-items-center justify-content-center border-round-lg"
                    style={{
                      width: "48px",
                      height: "48px",
                      backgroundColor: "rgba(62,139,92,0.1)",
                      color: "var(--extra-green)",
                    }}
                  >
                    {value.iconNode}
                  </div>
                  <div className="font-bold text-xl title mt-3" style={{ color: "var(--extra-green)" }}>
                    {value.title}
                  </div>
                  <div className="text-sm mt-2" style={{ color: "var(--extra-body)" }}>
                    {value.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* De um marketplace para uma infraestrutura */}
        <section className="full-width py-6 md:py-8" style={{ backgroundColor: "var(--extra-soft)" }}>
          <div className="grid align-items-center">
            <div className="col-12 lg:col-6">
              <div
                className="border-round-xl overflow-hidden"
                style={{ boxShadow: "0 20px 44px rgba(30,40,30,.12)" }}
              >
                <img
                  src={PadariaPhoto}
                  alt={localeText("lp2SobreInfraImgAlt")}
                  className="w-full"
                  style={{ aspectRatio: "4 / 3", objectFit: "cover", display: "block" }}
                />
              </div>
            </div>
            <div className="col-12 lg:col-6 mt-5 lg:mt-0 lg:pl-6">
              <p className="eyebrow-text">{localeText("lp2SobreInfraEyebrow")}</p>
              <h2
                className="mt-3 font-bold title text-3xl sm:text-4xl"
                style={{ color: "var(--extra-green)", letterSpacing: "-0.02em" }}
              >
                {localeText("lp2SobreInfraTitle")}
              </h2>
              <p className="mt-3 text-lg line-height-3" style={{ color: "var(--extra-body)" }}>
                {localeText("lp2SobreInfraDesc")}
              </p>
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="full-width py-5" style={{ backgroundColor: "var(--extra-green)" }}>
          <div className="flex flex-column lg:flex-row align-items-start lg:align-items-center justify-content-between gap-4">
            <div>
              <h2 className="font-bold title text-3xl sm:text-4xl text-white m-0">
                {localeText("lp2SobreCtaTitle")}
              </h2>
              <p className="mt-2 m-0" style={{ color: "rgba(255,255,255,0.75)", maxWidth: "48ch" }}>
                {localeText("lp2SobreCtaDesc")}
              </p>
            </div>
            <Link
              to="/planos"
              className="inline-flex align-items-center gap-2 border-round-md px-5 py-3 font-bold no-underline flex-shrink-0"
              style={{ backgroundColor: "#fff", color: "var(--extra-green)" }}
            >
              {localeText("lp2SobreCtaButton")} <i className="pi pi-arrow-right text-sm"></i>
            </Link>
          </div>
        </section>

        <LandingFooter />
        <LandingCopyright />
        <section
          className="py-4 full-width"
          style={{ backgroundColor: "#FFFFFF", color: "#5B6472", borderTop: "1px solid #DDE6E0" }}
        >
          <div className="flex flex-wrap align-items-center justify-content-between gap-3">
            <div
              className="flex flex-wrap align-items-center gap-2 text-xs"
              style={{ color: "#5B6472" }}
            >
              <span>EXTRACONOMY GLOBAL srl · Via Nomentana, 1018 - 00137 Roma (IT)</span>
              <span className="hidden md:inline">|</span>
              <span>P. Iva e C.F. 16948681008 | REA 1686351</span>
            </div>
            <Link to="/privacy" className="text-xs" style={{ color: "#5B6472" }}>
              Privacy Policy
            </Link>
          </div>
        </section>
      </div>

      <N8nChatbot isConfimeaCardVisible={false} />
    </div>
  );
};

export default SobrePage;
